import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'save',
    'unsave',
  ];

  static values = {
    experienceId: Number,
  };

  get experienceID() {
    return this.experienceIdValue;
  }

  get savedExperienceEl() {
    return document.querySelector(`[data-saved-experience="${this.experienceID}"]`);
  }

  connect() {
    const el = this.savedExperienceEl;
    if (el) {
      const saveID = el.dataset.save;
      this.saved(saveID);
    } else {
      this.notSaved();
    }
  }

  setUrl(saveID) {
    const form = this.unsaveTarget.querySelector('form');
    form.action = form.action.replace('__SAVE_ID__', saveID);
  }

  notSaved() {
    this.saveTarget.classList.remove('hidden');
    this.unsaveTarget.classList.add('hidden');
  }

  saved(id) {
    this.saveTarget.classList.add('hidden');
    this.unsaveTarget.classList.remove('hidden');
    this.setUrl(id);
  }
}
